import { IDS } from '../../settings-action-id.constants';
import { TAB_SELECT, TAB_SHOW } from '../../../../../common/tabs/tabs.constants'
import * as AccreditationActions from '../../../accreditation.actions';
import * as SettingsActions from "../../settings.actions";
import * as Actions from '../requirements.actions';
import {TYPES} from "../../settings-action-type.constants";
import {GRID_RELOAD} from "../../../../../common/grid/grid.constants";
import get from "lodash/get";

export const requirementsImports = {
    /* @ngInject */
    controller: function ($ngRedux, $state, $stateParams, $scope, $rootScope, $filter, NavigationService, AuthService, Notifier, FileActions, DocumentManager) {
        /**
         * @function $onInit
         */
        this.$onInit = async () => {
            this.identifier = IDS.accSettings;
            this.schemeCode = $stateParams.itemCode;
            const navConfig = NavigationService.getConfig($state.$current);
            this.colorName = navConfig.colorName;
            this.icon = navConfig.iconSvg.replace(/(\.\/)/g, '');
            this.parentState = IDS.app_accreditation_scheme_settings_requirements;

            this.unsubscribe = $ngRedux.connect(state => {
                const accSettings = state.accreditation.accSettings;
                return {
                    schemeName: accSettings.frameworkDetails.title,
                    location:   accSettings.requirementsImportsGrid.filter.loc_uuid,
                }
            }, {
                ...AccreditationActions,
                ...FileActions,
                ...SettingsActions,
                ...Actions,
            })(this);

            // this.getRegulatoryFrameworkDetails(this.schemeCode);
        }

        this.onButtonSave = (event) => {
            Notifier.info($filter('translate')('COMMON.NOTIFICATION.PLEASE_WAIT_DOTS'));
            const filePath = event[0].filePath
            this.importRequirementsFile(filePath, this.schemeCode).then(response => {
                $ngRedux.dispatch({
                    type: GRID_RELOAD,
                    id: IDS.accSettings,
                    path: IDS.requirementsImportsGrid,
                });
                this.fetchFrameworkRequirementsTree(this.schemeCode);
            });
        }

        this.onDownloadButton = ({item}) => {
            DocumentManager.downloadFile(item.import_file_uri);
        }

        this.$onDestroy = () => {
            this.unsubscribe();
        }
    },
    template: `
        <tabs-header title="Import History" icon="{{$ctrl.icon}}" color-name="{{$ctrl.colorName}}"></tabs-header>
        <requirements-imports-grid
            on-download="$ctrl.onDownloadButton($event)">
        </requirements-imports-grid>
        
        <div layout-xs="row" layout-gt-xs="row" flex>
            <form id="importForm" name="$ctrl.importForm" novalidate flex>
                <upload dropzone="true"
                        input-id="uploader"
                        label="Upload Excel File"
                        validate="true"
                        valid-type="xlsx"
                        identifier="requirementsImport"
                        save-button-label="Complete Import"
                        on-save="$ctrl.onButtonSave($event)">
                </upload>
            </form>
        </div>`
}